import Button from '@rio-cloud/rio-uikit/Button';

type AnimationPlaybackControlProps = {
    isPlaying: boolean;
    onPlay: () => void;
    onReset: () => void;
};

const AnimationPlaybackControl = ({ isPlaying, onPlay, onReset }: AnimationPlaybackControlProps) => (
    <div className='display-flex justify-content-center'>
        <Button bsStyle='primary' className='margin-right-10' onClick={onPlay} disabled={isPlaying}>
            Test animation
        </Button>
        <Button className='margin-left-10' onClick={onReset}>
            Reset
        </Button>
    </div>
);

export default AnimationPlaybackControl;
